/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowUp = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M12.5 3.9L6.7 9.7l1.1 1.1 4-4V20h1.4V6.7l4.5 4.1 1.1-1.1z" />
	</SVG>
);

export default arrowUp;
